"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Dimensions = /** @class */ (function () {
    function Dimensions(from, to) {
        this.From = from;
        this.To = to;
    }
    Dimensions.MinMax = function () {
        return new Dimensions(Number.MAX_VALUE, Number.MIN_VALUE);
    };
    Dimensions.add = function (x, y) {
        return new Dimensions(Math.min(x.From, y.From), Math.max(x.To, y.To));
    };
    return Dimensions;
}());
exports.default = Dimensions;
